<template>
  <export-pdf :loading="loading" filename="classificação_rfv" title="Classificação RFV" :subtitle="subtitle">
    <mf-pdf-item title="Classificação RFV" :name="$getLoggedUser().client">
      <div class="rfv-cards">
        <rfv-card-item v-for="variant in variants" :key="variant" :data="detailsData(variant)" :variant="variant" />
      </div>
    </mf-pdf-item>

    <mf-pdf-item title="Comparativo entre períodos" :name="$getLoggedUser().client">
      <div>
        <rfv-periods :formatted-pdf-dates="formattedPdfDates" />
        <rfv-table :variant="0" />
      </div>
    </mf-pdf-item>

    <mf-pdf-item title="Comparativo entre períodos" :name="$getLoggedUser().client">
      <div>
        <rfv-periods :formatted-pdf-dates="formattedPdfDates" />
        <rfv-table :variant="1" />
      </div>
    </mf-pdf-item>

    <mf-pdf-item title="Comparativo entre períodos" :name="$getLoggedUser().client">
      <div>
        <rfv-periods :formatted-pdf-dates="formattedPdfDates" />
        <rfv-table :variant="2" />
      </div>
    </mf-pdf-item>

    <mf-pdf-item title="Tabela de migração" :name="$getLoggedUser().client">
      <div class="full-width">
        <migration-table :loading-reference-period="false" :loading-current-period="false" is-export />
      </div>
    </mf-pdf-item>
  </export-pdf>
</template>

<script>
import ExportPdf from '@/components/ExportPdf.vue'
import RfvCardItem from './RfvCardItem'
import RfvPeriods from './RfvPeriods'
import RfvTable from './RfvTable'
import MigrationTable from '../comparison-between-periods/MigrationTable.vue'
import { mapGetters } from 'vuex'
import { QUERY_GET_ACCOUNT_IMAGES } from '@/modules/configuracoes-admin/graphql/index.js'

export default {
  name: 'RfvPdf',
  components: { ExportPdf, RfvCardItem, RfvPeriods, RfvTable, MigrationTable },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
      default: '',
    },
    formattedPdfDates: {
      type: Object,
      default: () => ({
        currentDates: '',
        referenceDates: '',
      }),
    },
  },
  computed: {
    ...mapGetters(['currentClientsMetrics', 'referenceClientsMetrics']),
    variants() {
      return ['champions', 'loyals', 'promising', 'atRisk', 'lowValue']
    },
    logoImage() {
      return this.hotsite?.images?.finish?.logo
    },
  },
  apollo: {
    hotsite: {
      query: QUERY_GET_ACCOUNT_IMAGES,
      fetchPolicy: 'network-only',
      update({ account }) {
        return account?.channels?.hotsite?.configuration?.assets
      },
    },
  },
  methods: {
    formatRecency(recency = 0) {
      if (recency === 0) return 'até 7 dias'
      else {
        const start = recency * 7 + 1
        const end = (recency + 1) * 7
        return `${start} a ${end} dias`
      }
    },
    detailsData(variant) {
      const clients = this.currentClientsMetrics?.[variant]?.metrics?.clients ?? 0
      return {
        clients: this.currentClientsMetrics?.[variant]?.metrics?.clients ?? '-',
        revenue: this.currentClientsMetrics?.[variant]?.metrics?.revenue ?? '-',
        frequency: this.currentClientsMetrics?.[variant]?.metrics?.frequency ?? '-',
        recency: this.formatRecency(this.currentClientsMetrics?.[variant]?.metrics?.recency) ?? '-',
        percentageRevenue: Math.round(this.currentClientsMetrics?.[variant]?.metrics?.percentageRevenue) ?? '-',
        channels: {
          app: clients ? (100 * this.currentClientsMetrics?.[variant]?.channels?.app) / clients : 0,
          email: clients ? (100 * this.currentClientsMetrics?.[variant]?.channels?.email) / clients : 0,
          sms: clients ? (100 * this.currentClientsMetrics?.[variant]?.channels?.sms) / clients : 0,
          whatsapp: clients ? (100 * this.currentClientsMetrics?.[variant]?.channels?.whatsapp) / clients : 0,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.rfv-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr) !important;
  gap: 8px;
  width: 100% !important;
}
::v-deep .full-width {
  width: 100%;
}
</style>
